import { AnthropicIcon, DeepSeekIcon, GeminiIcon, GrokIcon, MistralIcon, OpenAIIcon, OtomaticAIIcon } from "@Icons/index";
import _find from "lodash/find";

export const models = [
    // automatic
    {
        id: "automatic-1",
        provider: "automatic",
        group: "automatic",
        icon: OtomaticAIIcon,
        name: "Small",
        description: "Modèle léger, rapide et économique. Utilise actuellement le modèle OpenAI GPT-4.1-nano.",
        speed: 7,
        price: 0.4,
    },
    {
        id: "automatic-2",
        provider: "automatic",
        group: "automatic",
        icon: OtomaticAIIcon,
        name: "Medium",
        description: "Modèle standard. Utilise actuellement le modèle OpenAI GPT-4.1-mini.",
        speed: 5,
        price: 1.6,
    },
    {
        id: "automatic-3",
        provider: "automatic",
        group: "automatic",
        icon: OtomaticAIIcon,
        name: "Large",
        description: "Modèle haut de gamme. Utilise actuellement le modèle OpenAI GPT-4.1.",
        speed: 3,
        price: 8,
    },

    // openai
    {
        id: "gpt-5",
        provider: "openai",
        group: "openai",
        icon: OpenAIIcon,
        name: "GPT-5",
        description: "Modèle avancé pour une rédaction fluide, nuancée et contextuelle.",
        speed: 3,
        price: 10,
    },
    {
        id: "gpt-5-mini",
        provider: "openai",
        group: "openai",
        icon: OpenAIIcon,
        name: "GPT-5 mini",
        description: "Modèle avancé pour une rédaction fluide, nuancée et contextuelle.",
        speed: 5,
        price: 2,
    },
    {
        id: "gpt-5-nano",
        provider: "openai",
        group: "openai",
        icon: OpenAIIcon,
        name: "GPT-5 nano",
        description: "Modèle avancé pour une rédaction fluide, nuancée et contextuelle.",
        speed: 7,
        price: 0.4,
    },
    {
        id: "gpt-4.1",
        provider: "openai",
        group: "openai",
        icon: OpenAIIcon,
        name: "GPT-4.1",
        description: "Modèle hautement performant pour une génération de texte fluide, nuancée et contextuelle.",
        speed: 3,
        price: 8,
    },
    {
        id: "gpt-4.1-mini",
        provider: "openai",
        group: "openai",
        icon: OpenAIIcon,
        name: "GPT-4.1 mini",
        description: "Version compacte, efficace pour produire des textes clairs et structurés avec rapidité.",
        speed: 5,
        price: 1.6,
    },
    {
        id: "gpt-4.1-nano",
        provider: "openai",
        group: "openai",
        icon: OpenAIIcon,
        name: "GPT-4.1 nano",
        description: "Ultra léger et réactif, idéal pour générer du contenu simple avec une grande rapidité.",
        speed: 7,
        price: 0.4,
    },
    {
        id: "gpt-4o",
        provider: "openai",
        group: "openai",
        icon: OpenAIIcon,
        name: "GPT-4o",
        description: "Excellente maîtrise du langage pour produire des textes naturels et cohérents.",
        speed: 3,
        price: 10,
    },
    {
        id: "gpt-4o-mini",
        provider: "openai",
        group: "openai",
        icon: OpenAIIcon,
        name: "GPT-4o mini",
        description: "Modèle rapide et fluide, idéal pour générer des textes clairs et concis.",
        speed: 5,
        price: 0.6,
    },
    {
        id: "o4-mini",
        provider: "openai",
        group: "openai",
        icon: OpenAIIcon,
        name: "o4 mini",
        description: "Version optimisée pour la rapidité, idéale pour produire du contenu fluide et pertinent.",
        speed: 8,
        price: 4.4,
    },
    {
        id: "o3",
        provider: "openai",
        group: "openai",
        icon: OpenAIIcon,
        name: "o3",
        description: "Modèle avancé pour la rédaction de textes riches, bien articulés et contextuellement solides.",
        speed: 2,
        price: 8,
    },
    {
        id: "o3-mini",
        provider: "openai",
        group: "openai",
        icon: OpenAIIcon,
        name: "o3 mini",
        description: "Très bon pour produire des textes bien formulés avec un bon débit de réponse.",
        speed: 8,
        price: 4.4,
    },
    {
        id: "o1",
        provider: "openai",
        group: "openai",
        icon: OpenAIIcon,
        name: "o1",
        description: "Conçu pour générer des textes riches en détails et parfaitement structurés.",
        speed: 1,
        price: 60,
    },
    {
        id: "o1-mini",
        provider: "openai",
        group: "openai",
        icon: OpenAIIcon,
        name: "o1 mini",
        description: "Bonne capacité rédactionnelle avec un équilibre entre clarté et rapidité.",
        speed: 7,
        price: 4.4,
    },
    // mistral
    {
        id: "mistral-large",
        provider: "mistral",
        group: "mistral",
        icon: MistralIcon,
        name: "Mistral Large",
        description: "Très bon pour générer des contenus rédactionnels clairs et bien structurés.",
        speed: 5,
        price: 6,
    },

    // anthropic
    {
        id: "claude-4-5-sonnet",
        provider: "anthropic",
        group: "anthropic",
        icon: AnthropicIcon,
        name: "Claude 4.5 Sonnet",
        description: "Excellente cohérence dans la rédaction de textes informatifs ou créatifs.",
        speed: 3,
        price: 15,
    },

    {
        id: "claude-4-1-opus",
        provider: "anthropic",
        group: "anthropic",
        icon: AnthropicIcon,
        name: "Claude 4.1 Opus",
        description: "Le plus haut niveau d'intelligence et de capacité",
        speed: 2,
        price: 75,
    },

    // google
    {
        id: "gemini-2-flash-thinking",
        provider: "google",
        group: "google",
        icon: GeminiIcon,
        name: "Gemini 2 Thinking",
        description: "Idéal pour des textes nuancés ou des sujets nécessitant plus de réflexion.",
        speed: 2,
    },
    {
        id: "gemini-2.5-flash",
        provider: "google",
        group: "google",
        icon: GeminiIcon,
        name: "Gemini 2.5 Flash",
        description: "Bon équilibre entre vitesse et qualité d’écriture pour des réponses dynamiques.",
        speed: 7,
        price: 0.4,
    },
    {
        id: "gemini-2.5-pro",
        provider: "google",
        group: "google",
        icon: GeminiIcon,
        name: "Gemini 2.5 Pro",
        description: "Capable de produire des textes bien construits avec un style fluide.",
        speed: 4,
        price: 0.4,
    },

    // deepseek
    {
        id: "deepseek-chat",
        provider: "deepseek",
        group: "deepseek",
        icon: DeepSeekIcon,
        name: "DeepSeek V3",
        description: "Modèle efficace pour des contenus rédactionnels naturels et bien articulés.",
        speed: 4,
        price: 1.1,
    },
    {
        id: "deepseek-reasoner",
        provider: "deepseek",
        group: "deepseek",
        icon: DeepSeekIcon,
        name: "DeepSeek R1",
        description: "Très adapté à la génération de textes logiques et argumentés.",
        speed: 2,
        price: 2.19,
    },

    // grok
    {
        id: "grok-4",
        provider: "grok",
        group: "grok",
        icon: GrokIcon,
        name: "Grok 4",
        description: "Propose une rédaction originale et expressive, idéale pour les contenus créatifs.",
        speed: 4,
        price: 15,
    },
    {
        id: "grok-4-fast",
        provider: "grok",
        group: "grok",
        icon: GrokIcon,
        name: "Grok 4 Fast",
        description: "Propose une rédaction originale et expressive, idéale pour les contenus créatifs.",
        speed: 8,
        price: 0.5,
    },
];

export const getModel = (model) => {
    return _find(models, ["id", model]);
};

export const providers = [
    {
        id: "automatic",
        name: "Automatique",
    },
    {
        id: "openai",
        name: "OpenAI",
    },
    {
        id: "mistral",
        name: "Mistral AI",
    },
    {
        id: "groq",
        name: "Groq",
    },
    {
        id: "anthropic",
        name: "Anthropic",
    },
    {
        id: "google",
        name: "Google",
    },
    {
        id: "deepseek",
        name: "DeepSeek",
    },
    {
        id: "grok",
        name: "Grok (xAI)",
    },
];

export const getProvider = (provider) => {
    return _find(providers, ["id", provider]);
};

export const groups = [
    {
        id: "automatic",
        name: "Automatique",
    },
    {
        id: "openai",
        name: "OpenAI",
    },
    {
        id: "mistral",
        name: "Mistral",
    },
    {
        id: "anthropic",
        name: "Anthropic",
    },
    {
        id: "google",
        name: "Google",
    },
    {
        id: "deepseek",
        name: "DeepSeek",
    },
    {
        id: "grok",
        name: "Grok",
    },
];

export const getGroup = (group) => {
    return _find(groups, ["id", group]);
};
